export class Step<ID> {
  private _completed = false;

  constructor(public readonly id: ID) {}

  complete(): void {
    this._completed = true;
  }
}
